import Vue from 'vue'

Vue.mixin({
    methods: {
        removerMascaraTelefone(telefone) {
            return telefone ? telefone.replace(/\D/g,'') : ''
        }
    }
})
